import React, { useState } from 'react';
import { string, object, arrayOf, shape, any } from 'prop-types';
import Image from 'gatsby-image';
import ReactLightbox from 'react-images';

const propTypes = {
  images: arrayOf(shape({ src: any })),
  fluid: object,
  className: string,
};

const Lightbox = ({ images, fluid, className, ...other }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);

  function openLightbox(e) {
    if (e.target.tagName.toLowerCase() !== 'a') {
      setLightboxIsOpen(true);
    }
  }
  function closeLightbox() {
    setCurrentImage(0);
    setLightboxIsOpen(false);
  }
  function gotoPrevious() {
    setCurrentImage(currentImage - 1);
  }
  function gotoNext() {
    setCurrentImage(currentImage + 1);
  }
  return (
    <div onClick={e => openLightbox(e)}>
      <Image className={className} fluid={fluid} {...other} />
      <ReactLightbox
        images={images}
        onClose={() => closeLightbox()}
        onClickPrev={() => gotoPrevious()}
        onClickNext={() => gotoNext()}
        currentImage={currentImage}
        isOpen={lightboxIsOpen}
        showImageCount={false}
        onClickImage={() => closeLightbox()}
        onClick={() => closeLightbox()}
        backdropClosesModal
      />
    </div>
  );
};

Lightbox.propTypes = propTypes;

export default Lightbox;
